import { Footer, Header } from 'components'
import React, { useEffect } from 'react'

import { PrivacyPolicy as PrivacyPolicyContainer } from 'containers'
import { helmet } from 'utils';
import styles from './PrivacyPolicy.module.scss'

const SEO_Data = helmet({
  title: 'Datenschutz',
  description: 'Wir nehmen Datenschutz ernst und geben daher unser bestes Ihre Privatsphäre bestmöglich zu schützen.'
})

const PrivacyPolicy = () => {

  useEffect(() => {
    window.scroll(0,0)
  });

  return (
    <div>
      {/* Insert Helmet Data */}
      {SEO_Data}

      {/* Render Screen */}
      <Header />
      <article className={styles.content}>
        <PrivacyPolicyContainer />
      </article>
      <Footer />
    </div>
  )
}

export { PrivacyPolicy as default }